const parse = require('url-parse')

/**
 * UTM Helper Class
 */
class UTM {
  /**
   * Constructor
   * @param {string} [link = './']
   */
  constructor (link = './') {
    this.link = link
  }

  /**
   * get link extended by given UTM parameters
   * @link https://en.wikipedia.org/wiki/UTM_parameters
   * @param {Object} [utmParams = {}]
   * @param {string} utmParams.utmSource
   * @param {string} utmParams.utmMedium
   * @param {string} utmParams.utmContent
   * @param {string} utmParams.utmTerm
   * @param {string} utmParams.utmCampaign
   * @param {Object} utmParams.utmCustom
   * @param {boolean} cleanBeforeApply
   * @return string
   */
  getUTMLink (utmParams = {}, cleanBeforeApply = true) {
    const {
      utmSource,
      utmMedium,
      utmContent,
      utmTerm,
      utmCampaign,
      utmCustom = {}
    } = utmParams

    const utmQueryParams = {}

    if (utmSource) {
      utmQueryParams['utm_source'] = utmSource
    }

    if (utmMedium) {
      utmQueryParams['utm_medium'] = utmMedium
    }

    if (utmContent) {
      utmQueryParams['utm_content'] = utmContent
    }

    if (utmTerm) {
      utmQueryParams['utm_term'] = utmTerm
    }

    if (utmCampaign) {
      utmQueryParams['utm_campaign'] = utmCampaign
    }

    const url = parse(this.link, true)

    if (cleanBeforeApply) {
      Object.assign(url.query, utmQueryParams, utmCustom)
    } else {
      url.query = Object.assign({}, utmQueryParams, url.query, utmCustom)
    }

    return url.toString()
  }
}

export default UTM
